import styles from "./AssessmentProblems.module.scss";
import { classNames } from "@/shared/lib/classNames/classNames";

export const AssessmentProblems = () => {
    return (
        <div className={styles.assessmentProblems}>
            <div className={styles.title}>
                A person with mental tension feels{" "}
                <span>three types of problems:</span>
            </div>
            <div className={styles.content}>
                <div className={styles.block}>
                    <div className={styles.position}>01</div>
                    <div className={styles.blockTitle}>Dynamic tension</div>
                    <div className={styles.blockText}>
                        Hopelessness, mental fatigue, disappointment. We will
                        call this type of mental tension — dynamic tension.
                    </div>
                </div>
                <div className={classNames(styles.block, {}, [styles.second])}>
                    <div className={styles.position}>02</div>
                    <div className={styles.blockTitle}>Static tension</div>
                    <div className={styles.blockText}>
                        Despair, irritation, increased sensitivity. We will call
                        this type of mental tension — static tension.
                    </div>
                </div>
                <div className={classNames(styles.block, {}, [])}>
                    <div className={styles.position}>03</div>
                    <div className={styles.blockTitle}>Dynamic tension</div>
                    <div className={styles.blockText}>
                        Hopelessness, mental fatigue, disappointment. We will
                        call this type of mental tension — dynamic tension.
                    </div>
                </div>
                <div className={classNames(styles.colorBlock, {}, [])}>
                    <div className={styles.blockText}>
                        In these three states,{" "}
                        <strong>we are unable to control ourselves,</strong> we
                        cannot rest properly, and even sleep does not relieve
                        fatigue. This is the main difference from simple
                        physical fatigue.
                    </div>
                    <div className={styles.star} />
                </div>
            </div>
            <div className={styles.filledBlock}>
                <div className={styles.filledText}>
                    <strong>An important sign of tension</strong> is the
                    inability to control one’s mental functions. This condition
                    is subsequently also accompanied by physical fatigue, which
                    is also not relieved by sleep. From constant mental tension,
                    a person chronically loses strength. In the modern world,
                    mental tension is the main cause of both chronic diseases
                    and problems with work and personal life.
                </div>
                <div>
                    <div className={styles.filledTitle}>
                        What are energetic blockages?
                    </div>
                    <div className={styles.filledText}>
                        Energetic blockages are a negative accumulation of
                        energy in one of the zones of the energy layer. These
                        blockages cause difficulty in the movement of energy in
                        the body, which disrupts the regulation of both mental
                        and physiological processes. Such changes in energy
                        movement can have different degrees of density and
                        coverage width.
                    </div>
                </div>
            </div>
        </div>
    );
};
